module.exports = __webpack_public_path__ + "static/media/sg15cr93.2586ed25.png";